import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { AnalysesView } from "@/pages/AnalysesView";
import { Route as RootRoute } from "./__root";

/**
 * /analyses (TM-4c1fb82b) — раздел «Анализы по списку встреч». Гейтится
 * через `list_analysis_view` (admin-only).
 */
export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/analyses",
  component: () => (
    <RoleGuard action="list_analysis_view">
      <AnalysesView />
    </RoleGuard>
  ),
});
